<template>
  <transition name="fade">
    <add-place-button v-if="!isTileList" @click="handleClick"/>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import AddPlaceButton from './AddPlaceButton'

export default {
  components: {
    AddPlaceButton
  },
  computed: {
    ...mapGetters(['isTileList'])
  },
  methods: {
    handleClick () {
      this.$router.push({ name: 'add-step-1' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/AddPlaceButton/AddPlaceButtonContainer.vue